import { FunctionComponent } from "react";

import { classNames } from "@/utils/classNames";

import { TargetSegment } from "../schema/productsServices";

interface TargetSegmentChipsProps {
	segments: TargetSegment[];
	onToggle?: (segmentId: number) => void;
	readonly?: boolean;
}

export const TargetSegmentChips: FunctionComponent<TargetSegmentChipsProps> = ({
	segments,
	onToggle,
	readonly = false,
}) => {
	return (
		<div className="flex flex-wrap gap-2">
			{segments.map((segment) => (
				<button
					key={segment.id}
					className={classNames(
						"inline-flex items-center px-3 py-1.5 rounded-full text-xs font-medium transition-colors",
						segment.isActive ? "bg-[#eef2ff] text-[#4f46e5]" : "bg-[#f3f4f6] text-[#9ca3af]",
						readonly ? "cursor-default" : "cursor-pointer hover:opacity-80"
					)}
					disabled={readonly}
					type="button"
					onClick={() => onToggle?.(segment.id)}
				>
					{segment.isActive && <span className="mr-1">●</span>}
					{segment.name}
				</button>
			))}
		</div>
	);
};
